export const data = [
  {
    sector: 'Department Stores',
    more: 9,
    less: -44
  },
  {
    sector: 'Fast Fashion',
    more: 13,
    less: -24
  },
  {
    sector: 'Luxury',
    more: 16,
    less: -10
  },
  {
    sector: 'Value Chains',
    more: 17,
    less: -29
  },
  {
    sector: 'Mid-Priced Specialty',
    more: 18,
    less: -27
  },
  {
    sector: 'Subscription',
    more: 21,
    less: -6
  },
  {
    sector: 'Rental',
    more: 28,
    less: -5
  },
  {
    sector: 'Off-Price',
    more: 36,
    less: -13
  },
  {
    sector: 'Amazon Fashion',
    more: 37,
    less: -17
  },
  {
    sector: 'Sustainable Fashion',
    more: 43,
    less: -6
  },
  {
    sector: 'Secondhand',
    more: 52,
    less: -3
  }
];
